import ProductionSegment from "./ProductionSegment";
import type * as types from "../../../../types/types";
import { useRetrotagSegmentRange } from "utils/customHooks/retrotagSliceSelectors";
import { useJustRetrotagged } from "../RetrotagPopper/retrotagQueryHooks";

interface Props {
  processId: string;
  segments: types.ProductionSegmentType[];
  height: number;
  timelineIdx: number;
}

export default function ProductionSegments({
  processId,
  segments,
  height,
  timelineIdx,
}: Props) {
  const [justRetrotagged] = useJustRetrotagged();
  const retrotagSegmentRange = useRetrotagSegmentRange();
  return (
    <g>
      {segments.map(ps => {
        // re-render the segment if it was just retrotagged
        const wasJustRetrotagged =
          justRetrotagged &&
          retrotagSegmentRange &&
          ps.range.ge &&
          ps.range.lt &&
          ps.range.ge <= retrotagSegmentRange.ge &&
          ps.range.lt >= retrotagSegmentRange.lt;

        return (
          <ProductionSegment
            key={`${processId}-ps-${ps.range.ge}-justretrotagged-${wasJustRetrotagged}`}
            height={height}
            timelineIdx={timelineIdx}
            segment={ps}
            machemetryId={processId}
          />
        );
      })}
    </g>
  );
}
